/* eslint-disable @typescript-eslint/naming-convention */
// API Constants -------------------------------------
import { NEWRELIC_TABLES } from "@swiggy-private/swiggy-money-context/src";

export const ANDROID_APP_USER_AGENT = "swiggy-android";
export const IOS_APP_USER_AGENT = "swiggy-ios";
export const APP_USER_AGENTS = [ANDROID_APP_USER_AGENT, IOS_APP_USER_AGENT];
export const SUCCESS_RESPONSE_CODE = 0;

export const VERSION_CODE = "504";
export const OOPS_SOMETHING_WENT_WRONG = "Oops Something went wrong!";
export const DEFAULT_API_RETRY_DELAY_TIME_IN_MS = 100;

export const ENDPOINT = {
    CLAIM_VOUCHER: "/swiggymoney/voucher/claim",
    CHECK_ELIGIBILITY: "/payment/add-money/v1/order/transaction/eligibility",
    GET_OFFERS: "/payment/add-money/v1/order/offers",
    GET_LEDGER: "/payment/presentation/v1/swiggypay/statement",
    GET_BALANCE: "/payment/presentation/v1/swiggypay/getbalance",
    GET_REFUND_OPTIONS: "/payment/presentation/v1/refund/getDefault",
    SET_PREFERRED_REFUND_OPTION: "/payment/presentation/v1/refund/setDefault",
};

// Paths -------------------------------------
export enum SM_MONEY_PATHS {
    LEDGER_PATH = "/ledger",
    VOUCHER_PATH = "/voucher",
    HOW_IT_WORKS_PATH = "/how-it-works",
    LATEST_UPDATES = "/latest-updates",
    FAQ_PATH = "/faq",
    PAYMENTS = "/payments",
    GIFT_SELECTION = "/gift-card/selection",
    GIFT_SHARING = "/gift-card/sharing",
    GIFT_CARD_PAYMENTS = "/gift-card/payments",
    GIFT_REDEMPTION = "/gift-card/redemption",
    GIFT_CLAIMING = "/gift-card/claim",
}

export enum SCREEN_NAME {
    LEDGER = "LEDGER",
    VOUCHER = "VOUCHER",
}

export const SWIGGY_MONEY_ACTIVATION_URL = `${process.env.NEXT_PUBLIC_SWIGGY_API_HOST}/my-account/swiggy-money?referrer=swiggy_money_iw&callback_url=${process.env.NEXT_PUBLIC_SM_ACTIVATION_RETURN_URL}&onKYCSuccessClose=true`;

export const SWIGGY_MONEY_FAQ_URL = `${process.env.NEXT_PUBLIC_SWIGGY_API_HOST}/support/issues/swiggy_money_faq?hide_header=1`;

export const SWIGGY_MONEY_GIFT_CARD_FAQ_URL = `${process.env.NEXT_PUBLIC_SWIGGY_API_HOST}/support/issues/swiggy_money_gc_faq?hide_header=1`;

// Testing -------------------------------------
export const COMMON_TEST_IDS = {
    HEADER_BACK_ICON: "header-left-icon",
    HEADER_TITLE: "header-title",
    HEADER_SUB_TITLE: "header-sub-title",
    HEADER_BANK_ICON: "HEADER_BANK_ICON",

    NOTES_TITLE: "NOTES_TITLE",
    NOTES_LIST_ITEM: "NOTES_LIST_ITEM",

    TICK_MAIN_TEXT: "TICK_MAIN_TEXT",
    TICK_SUB_TEXT: "TICK_SUB_TEXT",

    BOTTOM_SHEET_MODAL: "BOTTOM_SHEET_MODAL",
    BOTTOM_SHEET_SCRIM: "BOTTOM_SHEET_SCRIM",
};

export const VOUCHER_TEST_IDS = {
    REDEEM_NOW_BUTTON: "REDEEM_NOW_BUTTON",
    OVERLAY_ERROR_TEXT: "OVERLAY_ERROR_TEXT",
};

export const LEDGER_TEST_IDS = {
    BALANCE_CARD_CONTAINER: "BALANCE_CARD_CONTAINER",
    AVAIL_BALANCE_TEXT: "AVAIL_BALANCE_TEXT",
    PENDING_BALANCE_TEXT: "PENDING_BALANCE_TEXT",

    ACCORDION_CONTAINER: "ACCORDION_CONTAINER",

    OFFERS_CONTAINER: "OFFERS_CONTAINER",
    OFFER_CARD: "OFFER_CARD",
    TRANSACTION_CONTAINER: "TRANSACTION_CONTAINER",
    EMPTY_TRANSACTION_CONTAINER: "EMPTY_TRANSACTION_CONTAINER",
    TRANSACTION_TAB: "TRANSACTION_TAB",
    TRANSACTION_ROW: "TRANSACTION_ROW",
    SHOW_OLD_TXN_BUTTON: "SHOW_OLD_TXN_BUTTON",

    HOW_IT_WORKS_LINK: "HOW_IT_WORKS_LINK",
    LATEST_UPDATES_LINK: "LATEST_UPDATES_LINK",
    FAQ_LINK: "FAQ_LINK",
    ADD_BALANCE_BUTTON: "ADD_BALANCE_BUTTON",
    REDEEM_NOW_LINK: "REDEEM_NOW_LINK",

    ALERT_CARD_CONTAINER: "ALERT_CARD_CONTAINER",
    ALERT_CARD_ICON: "ALERT_CARD_ICON",
};

export const GIFT_CARD_SELECTION_TEST_IDS = {
    BACK_BUTTON: "GC_BACK_BUTTON",
    TITLE_CONTAINER: "GC_TITLE_CONTAINER",
    FAQ_BUTTON: "GC_FAQ_BUTTON_CONTAINER",
    MAIN_BANNER_CONTAINER: "GC_BANNER_CONTAINER",
    AMOUNT_BOX_CONTAINER: "GC_AMOUNT_BOX",
};

export const HOW_IT_WORKS_IMAGE_URL = "portal/static-assets/images/swiggy-money/feb26.png";

export const SENDER_JOURNEY_FAQ = "portal/m/sm_gifting/FaqSenderJourney.png";

export const RECEIVER_JOURNEY_FAQ = "portal/m/sm_gifting/FaqReceiverJourney.png";

export const GIFT_CARD_LOTTIE_URL =
    "https://media-assets.swiggy.com/co-web-assets/swiggy-money/p2p-lottie-slowed-down.json";

export const SWIGGY_MONEY_TEXT = "Swiggy Money";

export const SHARE_TEXT = "Share gift voucher with a link";

export const ORDER_DETAILS = "Order ID";

export const VIEW_FAQ_TEXT = "View all FAQs";

export const START_ORDERING = "Start Ordering";

export const WILL_BE_CREDITED =
    "will be credited to Swiggy Money & can be used for all orders across Swiggy.";

export const GIFT_PPI_CONSTANTS = {
    POWERED_BY: "powered by",
    IMAGE: {
        WIDTH: 66,
        HEIGHT: 14,
        SRC: "payments/swiggy_money/rzp_logo.png",
    },
};

export const GO_TO_HOME = "Go to home";

export const ADDED_TO_SWIGGY_MONEY = "₹{0} added to Swiggy Money!";

export const LOG_TABLES = {
    LOG: NEWRELIC_TABLES.PORTAL_SWIGGY_MONEY_API,
    ERROR: NEWRELIC_TABLES.PORTAL_SWIGGY_MONEY_API_ERROR,
};
